import { z } from 'zod/v4';

/**
 * `POST /api/audits/:id/request` response: the status of the caller's latest
 * request after the call — `REQUESTED` for a new pending request, `APPROVED`
 * when a public audit was granted on the spot, or the existing status when a
 * public audit already had a request from the caller (nothing changes then).
 * The legacy route answered 200 with an empty body, which no caller read.
 */
export const RequestAuditAccessResponseSchema = z.object({
  auditId: z.string(),
  status: z.string(),
});

export type RequestAuditAccessResponse = z.infer<
  typeof RequestAuditAccessResponseSchema
>;
